import { IconProps } from '@ubnt/icons/typings-index-template';
import InfoIndicator from '@ubnt/link-core-ui/components/InfoIndicator/InfoIndicator';
import Text from '@ubnt/ui-components/Text/Text';
import { Children, memo } from 'react';

import { Flex } from 'components/Flex';

import classes from './SettingsTile.module.scss';

interface SettingsTileProps {
  icon?: React.ElementType<IconProps>;
  title?: string;
  info?: React.ReactNode;
  children?: React.ReactNode;
}

const SettingsTileImpl = (props: SettingsTileProps) => {
  const { icon: Icon, info, title, children } = props;

  const hasHeader = !!title;

  return (
    <div className={classes.settingsTile}>
      {hasHeader && (
        <Flex className={classes.tileRow} gap="s" alignCenter>
          {!!Icon && <Icon size="original" />}
          <Text color="primary" weight="bold" size="body">
            {title}
          </Text>
          {!!info && <InfoIndicator severity="info2">{info}</InfoIndicator>}
        </Flex>
      )}
      {Children.map(children, (child) => (
        <Flex className={classes.tileRow} gap="s" alignCenter>
          {child}
        </Flex>
      ))}
    </div>
  );
};

const SettingsTile = memo(SettingsTileImpl);

export default SettingsTile;
